<div class="encabezado">
  <div>
    <h5 class="titulo1">
      <i class="icon-telephone"></i> {{ "communication.voip.settings_title" | translate }}
    </h5>
  </div>
  <div class="btn-izq" *ngIf="!showForm">
    <button class="btn" type="button" (click)="openCreateForm()">
      <span class="add-btn-text">{{ "communication.voip.add_line" | translate }}</span>
      <i class="icon-plus"></i>
    </button>
  </div>
</div>

<!-- Lines List -->
<div *ngIf="!showForm">
  <div class="loading-state" *ngIf="isLoading">
    <div class="spinner-border text-primary" role="status"></div>
  </div>

  <div class="empty-state" *ngIf="!isLoading && lines.length === 0">
    <i class="icon-telephone"></i>
    <p>{{ "communication.voip.no_lines" | translate }}</p>
  </div>

  <div class="voip-lines-list" *ngIf="!isLoading && lines.length > 0">
    <div class="voip-line-card" *ngFor="let line of lines">
      <div class="line-header">
        <div class="line-label">
          <h6>{{ line.label }}</h6>
          <span class="badge bg-success" *ngIf="line.is_default">Default</span>
        </div>
        <div class="line-actions">
          <button class="btn btn-sm btn-outline-primary" (click)="openEditForm(line)"
            [title]="'buttons.edit' | translate">
            <i class="icon-pencil"></i>
          </button>
          <button class="btn btn-sm btn-outline-info" (click)="testConnection(line)"
            [title]="'communication.voip.test_connection' | translate">
            <i class="icon-checkmark-circle"></i>
          </button>
          <button class="btn btn-sm btn-outline-warning" (click)="syncWebhooks(line)"
            [title]="'communication.voip.sync_webhooks' | translate">
            <i class="icon-sync"></i>
          </button>
          <button class="btn btn-sm btn-outline-danger" (click)="deleteLine(line)"
            [title]="'buttons.delete' | translate">
            <i class="icon-trash"></i>
          </button>
        </div>
      </div>
      <div class="line-details">
        <div class="line-detail-row">
          <span class="detail-key">Caller ID</span>
          <span class="detail-val">{{ line.caller_id }}</span>
        </div>
        <div class="line-detail-row">
          <span class="detail-key">Account SID</span>
          <span class="detail-val text-truncate">{{ line.account_sid }}</span>
        </div>
        <div class="line-detail-row">
          <span class="detail-key">TwiML App</span>
          <span class="detail-val text-truncate">{{ line.twiml_app_sid }}</span>
        </div>
        <div class="line-detail-row">
          <span class="detail-key">{{ "communication.voip.recording" | translate }}</span>
          <span class="detail-val">
            <i [class]="line.recording_enabled ? 'icon-check text-success' : 'icon-cross text-danger'"></i>
          </span>
        </div>
        <div class="line-detail-row">
          <span class="detail-key">{{ "communication.voip.transcription" | translate }}</span>
          <span class="detail-val">
            <i [class]="line.transcription_enabled ? 'icon-check text-success' : 'icon-cross text-danger'"></i>
          </span>
        </div>
      </div>
      <!-- Webhook URLs backup -->
      <div class="line-webhooks" *ngIf="line.webhook_urls">
        <details>
          <summary>{{ "communication.voip.webhook_urls" | translate }}</summary>
          <div class="webhook-row">
            <span>Voice:</span>
            <code>{{ line.webhook_urls.voice }}</code>
            <button class="btn btn-sm btn-link" (click)="copyToClipboard(line.webhook_urls.voice)"><i class="icon-copy"></i></button>
          </div>
          <div class="webhook-row" *ngIf="line.webhook_urls.transcript">
            <span>Transcript:</span>
            <code>{{ line.webhook_urls.transcript }}</code>
            <button class="btn btn-sm btn-link" (click)="copyToClipboard(line.webhook_urls.transcript)"><i class="icon-copy"></i></button>
          </div>
          <p class="webhook-help">{{ "communication.voip.webhook_help" | translate }}</p>
        </details>
      </div>
    </div>
  </div>
</div>

<!-- Create/Edit Form -->
<div *ngIf="showForm" class="voip-form-container">
  <div class="getBack" (click)="closeForm()" style="cursor:pointer; margin-bottom: 16px;">
    <i class="icon-arrow-left"></i>
    <span>{{ "forms.buttons.back" | translate }}</span>
  </div>

  <h6>{{ editingLine ? ("communication.voip.edit_line" | translate) : ("communication.voip.add_line" | translate) }}</h6>

  <!-- Twilio prerequisites help -->
  <div class="alert alert-info mb-3" *ngIf="!editingLine">
    <strong>{{ "communication.voip.twilio_prerequisites_title" | translate }}</strong>
    <ol class="mb-0 mt-2">
      <li>{{ "communication.voip.twilio_prereq_1" | translate }}</li>
      <li>{{ "communication.voip.twilio_prereq_2" | translate }}</li>
      <li>{{ "communication.voip.twilio_prereq_3" | translate }}</li>
      <li>{{ "communication.voip.twilio_prereq_4" | translate }}</li>
      <li>{{ "communication.voip.twilio_prereq_5" | translate }}</li>
    </ol>
  </div>

  <form [formGroup]="form" (ngSubmit)="save()">
    <div class="row">
      <div class="col-12 mb-3">
        <label class="form-label">{{ "communication.voip.line_label" | translate }} <span class="required">*</span></label>
        <input class="form-control" formControlName="label" placeholder="Telemarketing Madrid" />
        <small class="error_validation" *ngIf="isFieldInvalid('label')">{{ formErrors['label'] || ("validation.required" | translate) }}</small>
      </div>

      <div class="col-6 mb-3">
        <label class="form-label">Account SID <span class="required">*</span></label>
        <input class="form-control" formControlName="account_sid" placeholder="AC..." />
        <small class="error_validation" *ngIf="isFieldInvalid('account_sid')">{{ formErrors['account_sid'] || 'Debe empezar con AC + 32 caracteres' }}</small>
      </div>

      <div class="col-6 mb-3">
        <label class="form-label">API Key SID <span class="required">*</span></label>
        <input class="form-control" formControlName="api_key_sid" placeholder="SK..." />
        <small class="error_validation" *ngIf="isFieldInvalid('api_key_sid')">{{ formErrors['api_key_sid'] || 'Debe empezar con SK + 32 caracteres' }}</small>
      </div>

      <div class="col-6 mb-3">
        <label class="form-label">API Key Secret {{ editingLine ? '' : '*' }}</label>
        <input class="form-control" type="password" formControlName="api_key_secret"
          [placeholder]="editingLine ? ('communication.voip.keep_empty' | translate) : ''" />
        <small class="error_validation" *ngIf="isFieldInvalid('api_key_secret')">{{ formErrors['api_key_secret'] || ("validation.required" | translate) }}</small>
      </div>

      <div class="col-6 mb-3">
        <label class="form-label">Auth Token {{ editingLine ? '' : '*' }}</label>
        <input class="form-control" type="password" formControlName="auth_token"
          [placeholder]="editingLine ? ('communication.voip.keep_empty' | translate) : ''" />
        <small class="error_validation" *ngIf="isFieldInvalid('auth_token')">{{ formErrors['auth_token'] || ("validation.required" | translate) }}</small>
      </div>

      <div class="col-6 mb-3">
        <label class="form-label">TwiML App SID <span class="required">*</span></label>
        <input class="form-control" formControlName="twiml_app_sid" placeholder="AP..." />
        <small class="error_validation" *ngIf="isFieldInvalid('twiml_app_sid')">{{ formErrors['twiml_app_sid'] || 'Debe empezar con AP + 32 caracteres' }}</small>
      </div>

      <div class="col-6 mb-3">
        <label class="form-label">{{ "communication.voip.caller_id" | translate }} <span class="required">*</span></label>
        <input class="form-control" formControlName="caller_id" placeholder="+34910000000" />
        <small class="error_validation" *ngIf="isFieldInvalid('caller_id')">{{ formErrors['caller_id'] || 'Formato E.164: +34...' }}</small>
      </div>

      <div class="col-6 mb-3">
        <label class="form-label">Intelligence Service SID</label>
        <input class="form-control" formControlName="intelligence_service_sid" placeholder="GA... (opcional)" />
      </div>

      <div class="col-6 mb-3">
        <label class="form-label">{{ "communication.voip.agent_channel" | translate }}</label>
        <select class="form-control" formControlName="agent_channel">
          <option [ngValue]="1">Canal 1</option>
          <option [ngValue]="2">Canal 2</option>
        </select>
      </div>

      <div class="col-4 mb-3">
        <div class="form-check form-switch">
          <input class="form-check-input" type="checkbox" formControlName="recording_enabled" id="recording_enabled" />
          <label class="form-check-label" for="recording_enabled">{{ "communication.voip.recording_enabled" | translate }}</label>
        </div>
      </div>

      <div class="col-4 mb-3">
        <div class="form-check form-switch">
          <input class="form-check-input" type="checkbox" formControlName="transcription_enabled" id="transcription_enabled" />
          <label class="form-check-label" for="transcription_enabled">{{ "communication.voip.transcription_enabled" | translate }}</label>
        </div>
      </div>

      <div class="col-4 mb-3">
        <div class="form-check form-switch">
          <input class="form-check-input" type="checkbox" formControlName="is_default" id="is_default" />
          <label class="form-check-label" for="is_default">{{ "communication.voip.is_default" | translate }}</label>
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-end gap-2 mt-3">
      <button class="btn btn-outline-secondary" type="button" (click)="closeForm()">{{ "buttons.cancel" | translate }}</button>
      <button class="btn btn-primary" type="submit" [disabled]="isSaving">
        <span class="spinner-border spinner-border-sm me-1" *ngIf="isSaving"></span>
        {{ "buttons.save" | translate }}
      </button>
    </div>
  </form>
</div>
